

































































import Vue from "vue";
import Component from "vue-class-component";
import { Audit as AuditInterface } from "../../services/audit/entities/audit.interface";
import SingleAudit from "../../components/admin/SingleAudit.vue";
import { Watch } from "vue-property-decorator";
import constants from "../../config/constants";

@Component({
  components: {
    SingleAudit
  }
})
export default class Audit extends Vue {
  loadingAudit = false;
  page = 1;

  private created(): void {
    this.loadingAudit = true;
    this.$store
      .dispatch("audit/getAudit", {
        start: 0,
        quantity: constants.ITEMS_PER_PAGE
      })
      .finally(() => {
        this.loadingAudit = false;
      });
  }

  private get audits(): Array<AuditInterface> {
    const audits = this.$store.getters["audit/getAudit"];
    return audits;
  }

  private get totalAudits(): number {
    const totalAudits = this.$store.getters["audit/getTotalAudits"];
    return totalAudits;
  }

  @Watch("page")
  private getAudits(): void {
    this.loadingAudit = true;
    this.$store
      .dispatch("audit/getAudit", {
        start: this.page * constants.ITEMS_PER_PAGE - constants.ITEMS_PER_PAGE,
        quantity: constants.ITEMS_PER_PAGE
      })
      .finally(() => {
        this.loadingAudit = false;
      });
  }

  private get totalPages(): number {
    const audits = this.totalAudits;
    const total = audits / constants.ITEMS_PER_PAGE;
    if (total > Math.round(total)) {
      return Math.round(total) + 1;
    } else {
      return Math.round(total);
    }
  }
}
